const paramMap = {
    ul_cpuname: 'cpuName',
    ul_gpuname: 'gpuName',
    ul_gputype: 'gpuType',
    ul_gpunumber: 'gpuNumber',
    ul_cpuoc: 'cpuOC',
    ul_memchannels: 'memchannels',
    ul_memfrequency: 'memfrequency',
};
export const graphicsPresets = ['fullHdFps', 'quadHdFps'];
const pickParams = params => {
    return Object.keys(params).reduce((r, k) => {
        const mappedKey = paramMap[k];
        if (mappedKey) {
            r[mappedKey] = params[k];
        }
        return r;
    }, {});
};

export const getULParams = (skuList, ULList) => {
    const params = Object.keys(ULList || {}).reduce((r, sku) => {
        if (skuList.includes(sku)) {
            //TODO: temp add default parameter for testing
            r = { gpuNumber: 1, ...r, ...pickParams(ULList[sku]) };
        }
        return r;
    }, {});
    //if not all required params provided throw and execption
    if (Object.keys(params).length !== Object.keys(paramMap).length) {
        throw new Error(`Missing required parameters. Received ${JSON.stringify(params)}`);
    }
    return params;
};

export const pickFPS = (game, gameTitles, graphicPreset) => {
    const fpsValue = ((gameTitles || {})[game.title || game.gameName] || {})[graphicPreset];
    return fpsValue ? `${fpsValue} FPS` : fpsValue;
};
